import { getMaxWidthForWaveform, Timestamp, toTimestamp } from '@mi-front/core';
import { Stream } from '@mi-front/ui';
import { DisplayableChunk } from '../../../../../../types';
import { ChunkMarkers } from './ChunkMarkers';
import { ChunkWaveformSvg } from './ChunkWaveformSvg';
import { StreamWrapper } from './StreamWrapper';

const WAVEFORM_HEIGHT = 58;

interface ChunkStreamProps {
  chunk: DisplayableChunk;
}

/**
 * Renders the waveform stream for a chunk.
 * Contains the Stream component with waveform SVG and interactive markers.
 */
export function ChunkStream({ chunk }: ChunkStreamProps) {
  const maxWidth = getMaxWidthForWaveform(chunk.segments);
  const startTs = toTimestamp(chunk.from);
  const stopTs = toTimestamp(chunk.to);

  return (
    <StreamWrapper
      style={{
        width: '100%',
        maxWidth,
      }}
    >
      <Stream
        className="border"
        range={{
          from: startTs,
          to: stopTs,
        }}
        height={WAVEFORM_HEIGHT}
        renderSvg={() => (
          <ChunkWaveformSvg relativeTs={startTs as Timestamp} chunk={chunk} color={chunk.color} />
        )}
        renderHtml={() => <ChunkMarkers chunk={chunk} />}
      />
    </StreamWrapper>
  );
}
